import { useCallback, useMemo } from 'react';

import { useSelectedView } from 'reducers/viewsSlice';

import { COHORT_TYPES_GOALS, MODULE_KEYS_USER_PREFERENCE_PERSISTENCE } from 'constants/ProjectConstants';
import { getPersistenceKey } from 'constants/helper';
import { routes } from 'constants/routes';

import { UserDataPersistenceService } from 'services/UserDataPersistenceService';

// export const useShowParentObjectivesPersistence = (props) => {
//   // const { defaultShowParent = false } = props ?? {};

//   // const history = useHistory();
//   // const location = history.location;

//   const sideNavSelectedCohort = useSelectedView();
//   const viewId = sideNavSelectedCohort?.id;
//   // const viewType = sideNavSelectedCohort?.type;

//   /* Grid State persistence Key */
//   const persistenceKey = useMemo(() => {
//     const moduleName = MODULE_KEYS_USER_PREFERENCE_PERSISTENCE.GOAL;
//     const tabId = 'Explore';
//     const uniqueId = null;

//     return getPersistenceKey({
//       moduleName,
//       viewId,
//       tabId,
//       uniqueId,
//     });
//   }, [viewId]);

//   const setShowParentPersistence = useCallback(
//     (value) => {
//       UserDataPersistenceService.set(persistenceKey, { showParent: value });
//     },
//     [persistenceKey]
//   );

//   return {
//     setShowParentPersistence,
//   };
// };

export const getGoalsPathnameToRedirectTo = ({ cohort }) => {
  const viewId = cohort?.id;
  const viewType = cohort?.type;

  const isAllEmployeesView = viewType === COHORT_TYPES_GOALS.ALL_EMPLOYEE;

  const moduleName = MODULE_KEYS_USER_PREFERENCE_PERSISTENCE.GOAL;
  const tabId = 'Explore';
  const uniqueId = null;

  /* Grid State persistence Key */
  const persistenceKey = getPersistenceKey({
    moduleName,
    viewId,
    tabId,
    uniqueId,
  });

  let persistedState = null;
  try {
    const item = localStorage.getItem(persistenceKey);
    const returnValue = item ? JSON.parse(item) : null;
    persistedState = returnValue;
  } catch (error) {
    console.error('Error while getting persisted state', error);
  }
  const persistedValue = persistedState?.showParent;

  return isAllEmployeesView ? routes.goals.audit : persistedValue ? routes.goals.audit : routes.goals.list;
};

export const getGoalsPersistedValue = ({ cohort }) => {
  const viewId = cohort?.id;
  const viewType = cohort?.type;

  const isAllEmployeesView = viewType === COHORT_TYPES_GOALS.ALL_EMPLOYEE;

  const moduleName = MODULE_KEYS_USER_PREFERENCE_PERSISTENCE.GOAL;
  const tabId = 'Explore';
  const uniqueId = null;

  /* Grid State persistence Key */
  const persistenceKey = getPersistenceKey({
    moduleName,
    viewId,
    tabId,
    uniqueId,
  });

  let persistedState = null;
  try {
    const item = localStorage.getItem(persistenceKey);
    const returnValue = item ? JSON.parse(item) : null;
    persistedState = returnValue;
  } catch (error) {
    console.error('Error while getting persisted state', error);
  }
  const persistedValue = persistedState?.showParent;

  return {
    persistedValue,
  };
};
